import React, { forwardRef } from 'react';
import {USState} from '@capsovision/capso_utils';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';


const StateSelect = forwardRef((props, ref) => {

	return (
		<FormControl fullWidth>
			<InputLabel id="state-select-label">State</InputLabel>
			<Select
				labelId="state-select-label"
				id="state"
				label="State"
				ref={ref}
				{...props}
			>
				{
					Object.keys(USState).map(key => {
						return (
							<MenuItem key={key} value={key}>{USState[key]}</MenuItem>
						)
					})
				}
			</Select>
		</FormControl>
	)
})

StateSelect.displayName = 'StateSelect';

export default StateSelect;